module.exports = __webpack_public_path__ + "img/Hickory 960x1080.4a1ee277.png";